import React, { useEffect, useState } from "react";
import NoData from "../../../../../components/noData/noData";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import { Icons } from "../../../../../../utils/icons";
import { useNavigate } from "react-router-dom";

// Reusable DetailCard component
const DetailCard = ({ label, value }) => (
  <div className="grid grid-cols-2">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-semibold text-blue-900">
      {Array.isArray(value) ? (
        <div className="flex flex-wrap gap-2">
          {value.map((tag, i) => (
            <span
              key={i}
              className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded-full"
            >
              {tag.trim()}
            </span>
          ))}
        </div>
      ) : (
        value || "-"
      )}
    </span>
  </div>
);


// Skeleton Loader
const DetailSkeleton = () => (
  <div className="grid grid-cols-2 animate-pulse">
    <div className="h-5 bg-gray-300 rounded w-3/4 mb-2" />
    <div className="h-5 bg-gray-200 rounded w-2/3 mb-2" />
  </div>
);

const BasicCard = ({ stockData, loading }) => {
  const navigate = useNavigate();

  useEffect(() => {
  }, [stockData]);

  if (loading) {
    return (
      <div className="flex flex-col gap-2 rounded-md h-full">
        {Array.from({ length: 3 }).map((_, idx) => (
          <DetailSkeleton key={idx} />
        ))}
      </div>
    );
  }

  if (!stockData) {
    return (
      <p className="text-gray-500 p-4 bg-white rounded-md">
        <NoData
          title="No Result Found"
          message="Please try again with another keywords or maybe use generic term"
          buttonText={null}
        />
      </p>
    );
  }
  const stockOverviewDetails = [
    { label: "Name", value: stockData?.name },
    { label: "Category", value: stockData?.category?.name || "-" },
    {
      label: "Parent Category",
      value: stockData?.category?.parentCategory?.name || "-",
    },
    {
      label: "Stock Type",
      value: stockData?.stock_type === 0 ? "Consumable" : "Fixed",
    },
    {
  label: "Tags",
  value: stockData?.tags
    ? stockData.tags.split(",").filter((t) => t.trim() !== "")
    : [],
},
  ];
  
  const stockQuantityDetails = [
    { label: "Total Quantity", value: stockData?.total_quantity || "0" },
    { label: "Assigned Quantity", value: stockData?.assigned_quantity || "0" },
    {
      label: "Available Quantity",
      value: stockData?.available_quantity || "0",
    },
    {
      label: "Reorder Level",
      value: stockData?.reorder_level || "0",
    },
  ];

  const stockDescription = [
    { label: "Description", value: stockData?.description },
  ];

  return (
    <div className="flex flex-col gap-2 rounded-md h-full">
      {/* Basic Details */}
      <div>
        <div className="border-b flex justify-between p-4 text-lg font-semibold text-blue-900 bg-white px-4 py-2">
          <h2 className="text-lg font-semibold text-blue-900">Basic Details</h2>
          <DefaultButton
            name={Icons.EDIT}
            onClick={() => navigate(`/inventory/stock/edit/${stockData.uuid}`)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div className="bg-white p-4 flex flex-col gap-2">
              {stockOverviewDetails.map((item, idx) => (
                <DetailCard key={idx} label={item.label} value={item.value} />
              ))}
            </div>
            <div className="bg-white p-4 flex flex-col gap-2">
              {stockQuantityDetails.map((item, idx) => (
                <DetailCard key={idx} label={item.label} value={item.value} />
              ))}
            </div>
          </div>
          <div className="bg-white p-4">
            {stockDescription.map((item, idx) => (
              <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-500">{item.label}</span>
                <span className="text-sm font-semibold text-blue-900">
                  {item.value || "-"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicCard;
